import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { DrillingSession } from '../models/drilling.models';

/** Pure presentational component: renders a single colored drill-session block. */
@Component({
  selector: 'drill-block',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './drill-block.component.html',
  styleUrls: ['./drill-block.component.scss'],
})
export class DrillBlockComponent {
  readonly session    = input.required<DrillingSession>();
  readonly color      = input.required<string>();

  readonly blockClick = output<DrillingSession>();

  protected readonly tooltip = computed(() => {
    const s = this.session();
    const lines: string[] = [
      `${s.equipmentLabel}  ·  ${s.operatorLabel}`,
      `Date: ${s.date}`,
      `Engine: ${+s.engineHours.toFixed(1)}h  ·  Pause: ${+s.pauseHours.toFixed(1)}h`,
      `Drilled: ${s.drilledMeters} m`,
    ];
    return lines.join('\n');
  });
}
